import type { PropsWithChildren } from "react";
import { useMemo } from "react";

import useSplashScreenController from "@/controllers/useSplashScreenController";
import { SplashScreenContext } from "@/hooks/useSplashScreen";
import EquipSplashScreen from "@/ui/components/splashScreen/EquipSplashScreen";
import { Box } from "@/ui/layout";

const SplashScreenProvider = ({ children }: Readonly<PropsWithChildren>) => {
  const {
    disable: disableSplashScreen,
    enable: enableSplashScreen,
    isVisible: isSplashScreenVisible,
  } = useSplashScreenController();

  // this memoization may seem unnecessary, but this prevents needless rerenders
  // (potentially on every single render) due to the literal object {} being used directly
  const value = useMemo(
    () => ({
      disableSplashScreen,
      enableSplashScreen,
      isSplashScreenVisible,
    }),
    [disableSplashScreen, enableSplashScreen, isSplashScreenVisible],
  );
  return (
    <SplashScreenContext.Provider value={value}>
      {children}
      {isSplashScreenVisible && (
        <Box bottom={0} flex={1} position="absolute" top={0} width="100%">
          <EquipSplashScreen />
        </Box>
      )}
    </SplashScreenContext.Provider>
  );
};

export default SplashScreenProvider;
